import { FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Range } from '@anduin/shared';

export const dateRangeValidator: ValidatorFn = (
  group: FormGroup<Range<FormControl<number | string | Date>>>,
): ValidationErrors | undefined => {
  const min = group.get('min');
  const max = group.get('max');

  // Both inputs should be filled to be validated
  if (!min?.value || !max?.value) {
    return;
  }

  if (startOfDay(min.value) > startOfDay(max.value)) {
    return { minAfterMax: true };
  }

  return;
};

function startOfDay(value: number | string | Date): number {
  return new Date(value).setHours(0, 0, 0, 0);
}
